import eventHub from "../eventHub";

export default {
    data() {
        return {
            select_all: false,
            row_checkbox: [],
        }
    },
    mounted() {
        window.eventHub.$on('clear-checked', this.clearChecked);
    },
    beforeDestroy() {
        window.eventHub.$off('clear-checked');
    },
    methods : {
        clearChecked() {
            this.select_all = false;
            this.row_checkbox = [];
        },
        clickCheckBox(value) {
            if(value == 'select_all') {
                this.select_all = !this.select_all;
                this.selectAllCheckbox(this.select_all);
                return;
            }

            let found = this.row_checkbox.includes(value);

            if(!found) {
                this.row_checkbox.push(value);
            } else {
                this.row_checkbox.splice(this.row_checkbox.indexOf(value), 1);
            }
        },
        selectAllCheckbox(all) {
            this.row_checkbox = [];
            _.each(this.table_data.data, (row, index) => {
                if(all) {
                    if(typeof row.can_edit == 'undefined') {
                        this.row_checkbox.push(row.id);
                    } else {
                        if(row.can_edit) {
                            this.row_checkbox.push(row.id);
                        }
                    }
                }
            })
        },

        getCheckedValue() {
            return this.row_checkbox;
        },

        /**
         * modal submit function.
         * ie. @click="modal_area.modalSubmit('post', '#')"
         *
         *    the following is for close the modal
         *    data-toggle="modal"
         *    data-target="#CustomModal"
         *
         * Supported parsing array through request to server side.
         */

        modalSubmit(method, url) {
            return this.modalSubmitWithData(method, url, null);
        },
        modalSubmitWithData(method, url, data) {

            let formData = new FormData();
            formData.append('checkbox', this.row_checkbox);

            _.each(this.row_checkbox, (checked, index) => {
                formData.append('checkbox[]' , checked);
            });

            let ajaxSuccessCallback = (response) => {
                this.$nextTick(function() {
                    this.row_checkbox = [];
                    eventHub.$emit('plain-list-reload-data'); // For PlainListing
                    eventHub.$emit('list-reload-data'); // For Table
                    this.$store.commit('setNotificationType', 'success');
                    this.$store.commit('setNotification', response.data.msg);
                });
            };
            let ajaxFailCallback = (error) => {
                if (error.response.status == '422') {
                    let system_error = error.response.data.errors;
                    let errors = {};
                    Object.keys(system_error).forEach((key) => {
                        errors[key] = system_error[key];
                    })

                    this.$store.commit('setValidationError', errors);
                } else {
                    this.$store.commit('setError', (typeof error.response.data.msg != 'undefined' ? error.response.data.msg : 'Failure'));
                }
            };

            if(method == 'patch') {
                this.$root.ajax_patch(url, formData, ajaxSuccessCallback, ajaxFailCallback, true, {headers: {'Content-Type': 'multipart/form-data' }});
            } else if(method == 'post') {
                this.$root.ajax_post(url, formData, ajaxSuccessCallback, ajaxFailCallback, true, {headers: {'Content-Type': 'multipart/form-data' }});
            } else {
                console.log()
            }
        },
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/checkBoxInTable.js